import http from 'axios'
import { deleteUseless } from '../../lib/formatParams/index'

export default {
  namespaced: true,
  state: {
    // token: '',
    token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1bmlvbmlkIjoiODE0NjcyIiwidW5pb25uYW1lIjoiZ2pycnh1ZSIsInN0YWZmaWQiOjMyOTUsInN0YWZmbmFtZSI6ImNoZW5tYW4xMjMiLCJ1c2Vycm9sZSI6MzIzMSwidW5pb250eXBlIjoyLCJpc3N1ZXIiOiJ1bmlvbiIsImF1ZGllbmNlIjoiIn0.tcvrPgmvcnAyyME_44gdDpvuutrs9hcZiTsEHb73cO0'
  },
  actions: {
    // 获取市场联系老师
    GetContactTeacher({ state }) {
      return new Promise((resolve, reject) => {
        http.get("/v1/register/GetContactTeacher")
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 注册验证第一步信息
    VaildRegisterTeacher({ state }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/register/VaildRegisterTeacher", deleteUseless(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 联盟注册
    AdminRegister({ commit }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/register/AdminRegister", deleteUseless(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              commit("updataToken", data.msg)
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 3种登录方式 1 手机+密码 2 用户+密码 3 手机+验证码
    AdminLogin({ commit }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/register/AdminLogin", deleteUseless(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              commit("updataToken", data.msg)
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 退出登录
    AdminLoginOut({ commit }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/register/AdminLoginOut", params)
          .then(({ data }) => {
            if (data.s === 10006) {
              commit("updataToken", "")
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    }
  },
  mutations: {
    updataToken(state, params) {
      state.token = params
    }
  },
  getters: {
    token(state) {
      return state.token
    }
  }
}